<template>
    <div class="container-fluid client min-vh-100 client-bids">
      <div class="clientWrap">
        <div class="row">
          <div class="col-md-12 py-4 text-left">
            <div class="d-flex justify-content-between align-items-center">
              <h1 id="v-step-0">{{ isAdmin || isRep ? 'User' : 'My' }} Bids/ Buys</h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="dark-filter w-100 p-1 mb-2 d-inline-block">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="ml-3 m-0">Filters</h5>
                <span class="btn btn-link" @click="showFilters = !showFilters">
                  <i
                    class="fa"
                    v-bind:class="[
                      showFilters ? 'fa-angle-up' : 'fa-angle-down'
                    ]"
                  ></i>
                  {{ showFilters ? 'Hide' : 'Show' }} Filters
                </span>
              </div>
              <div class="row p-4" v-if="showFilters">
                <div class="col-lg-12">
                  <form class="row">
                      <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">From</label>
                      <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">To</label>
                      <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">CUSIP</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="searchValue"
                        placeholder="Enter CUSIP"
                      />
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">Status</label>
                      <select class="form-control" v-model="selectedStatus">
                        <option value="">All</option>
                        <option value="PENDING">PENDING</option>
                        <option value="FILLED">FILLED</option>
                        <option value="REJECTED">REJECTED</option>
                      </select>
                    </div>
                    <div class="col-md-6 col-lg-3 mt-2">
                      <label for="filter" class="">Type</label>
                      <select class="form-control" v-model="selectedType">
                        <option value="">All</option>
                        <option value="BUY">BUY</option>
                        <option value="BID">BID</option>
                      </select>
                    </div>
                    <div class="col-md-6 col-lg-3 mt-2" v-if="isRep || isAdmin">
                  <label for="filter" class="">User</label>
                    <multiselect
                        v-model="selectClient"
                        placeholder="Select"
                        :options="clientList"
                        :multiple="false"
                        label="clientFullName"
                        track-by="id"
                    ></multiselect>
                  <!-- <select class="form-control" v-model="selectClient">
                    <option value="" disabled selected>Select Client</option>
                  
                    <option
                      v-for="client in clientList"
                      :key="client.id"
                      :value="client.clientFullName"
                    >
                      {{ client.clientFullName }}
                    </option>
                  </select> -->
                </div>
                    <div class="col-md-6 col-lg-3 mt-3">
                      <button
                        @click="clear()"
                        type="button"
                        class="btn btn-secondary rounded mt-4"
                      >
                        Clear
                      </button>
                      <button
                        @click="search()"
                        type="button"
                        class="btn btn-primary rounded mt-4"
                      >
                        Filter
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="history filter-list">
              <div class="table-responsive p-0">
                <table class="table table-striped table-hover mybids">
                  <thead>
                    <tr>
                      <th 
                        scope="col" 
                        class="sort text-left"
                        v-if="isAdmin || isRep"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'clientFirstName'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'clientFirstName'
                          ? 'sort-client-desc'
                          : '',
                        ]"
                        @click="sort('clientFirstName')"
                        >Client</th>
                      <th 
                        scope="col"
                        class="sort text-left"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'createdAt'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'createdAt'
                          ? 'sort-client-desc'
                          : '',
                        ]"
                        @click="sort('createdAt')"
                        >Trade Date</th>
                      <th 
                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'cusip'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'cusip'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('cusip')"
                      >CUSIP</th>
                      <th 
                        scope="col" 
                        class="sort text-left"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'description'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'description'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('description')"
                      >description</th>
                      <th 
                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'bidType'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'bidType'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('bidType')"
                      >TYPE</th>
                      <th 
                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'quantity'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'quantity'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('quantity')"
                      >BID QTY</th>
                      <th 
                        scope="col" 
                        class="sort text-right"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'price'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'price'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('price')"
                      >BID PRICE</th>
                       <th 
                       v-if="isAdmin || isRep"
                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'spread'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'spread'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('spread')"
                      >USER SPREAD</th>
                       <th 
                       v-if="isAdmin || isRep"

                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'offerPrice'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'offerPrice'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('offerPrice')"
                      >LISTED PRICE</th>
                      
                      <th 
                        scope="col" 
                        class="sort text-center"
                       v-if="isAdmin || isRep"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'offerQuantity'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'offerQuantity'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('offerQuantity')"
                      >SOURCE QTY</th>
                       <th 
                        v-if="isAdmin || isRep"

                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'sourcePrice'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'sourcePrice'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('sourcePrice')"
                      >SOURCE PRICE</th>
                       <th 
                       v-if="isAdmin || isRep"

                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'ecn'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'ecn'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('ecn')"
                      >SOURCE ECN</th>
                      <th 
                        scope="col" 
                        class="sort text-center"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'status'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'status'
                          ? 'sort-client-desc'
                          : '',
                      ]"
                      @click="sort('status')"
                        
                        >Status</th>
                      <th scope="col" class="text-center" > 
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <div class="loader" v-if="loading"></div>

                    <tr v-if="bids.length == 0 && !loading">
                      <td colspan="6">
                        <p class="nodata text-white">No data available</p>
                      </td>
                    </tr>
                    <tr v-for="bid in bids" :key="bid.id">
                      <td v-if="isAdmin || isRep">
                       <span class="client-name">{{ bid.clientFirstName }} {{ bid.clientLastName }}</span>  
                      </td>
                      <td>
                        {{
                          bid.createdAt
                            ? moment(bid.createdAt).format('MM/DD/YYYY')
                            : 'N/A'
                        }}
                      </td>
                      <td class="text-center">{{ bid.cusip }}</td>
                      <td class="text-left">{{ bid.description }}</td>
                      <td
                        class="text-center"
                        :class="{
                          'text-primary': bid.bidType === 'BID',
                          'text-success': bid.bidType === 'BUY'
                        }"
                      >
                        {{ bid.bidType }}
                      </td>
                      <td class="text-center">{{ bid.quantity }}</td>
                      <td class="text-right">
                        <span v-if="bid.price"  class="mr-3">{{ bid.price | currency }}</span>
                      </td>
                      <td class="text-center" v-if="isAdmin || isRep">{{ bid.spread }}</td>
                      <td class="text-center" v-if="isAdmin || isRep">{{ bid.offerPrice  | currency}}</td>
                      <td class="text-center" v-if="isAdmin || isRep">{{ bid.offerQuantity }}</td>
                      <td class="text-center" v-if="isAdmin || isRep">
                        {{ bid.sourcePrice | currency}}
                      </td>
                      <td class="text-center" v-if="isAdmin || isRep">{{ bid.ecn }}</td>


                      <td
                        class="text-center"
                        :class="{
                          'text-orange': bid.status === 'PENDING',
                          'text-success': bid.status === 'FILLED',
                          'text-danger': (bid.status === 'REJECTED' || bid.status === 'DELETED') 
                        }"
                      >
                       <!-- <select v-if="isRep || isAdmin" class="form-control" v-model="bid.status"> 
                        
                          <option value="PENDING">PENDING</option>
                          <option value="FILLED">FILLED</option>
                          <option value="REJECTED">REJECTED</option>
                        </select> -->
                       <span >{{ bid.status == 'FILLED' ? 'BOUGHT' : bid.status }}</span>
                      </td>
                      <td class="text-center" >
                         <button
                            v-if="bid.status === 'PENDING' && isClient"
                            @click="updateBidPriceModal(bid)"
                            class="btn btn-primary rounded mt-2"
                            type="button"
                            data-toggle="tooltip"
                            title="Update Bid Price"
                          >
                            <i class="fa fa-edit"></i> Update
                          </button>
                          
                           <button
                            v-if="bid.status === 'PENDING' && isClient"
                            @click="deleteBid(bid)"
                            class="btn btn-danger rounded mt-2"
                            type="button"
                            data-toggle="tooltip"
                            title="Delete Bid"
                          >
                            <i class="fa fa-trash"></i> Delete
                          </button>
                         <button
                         v-if="bid.status === 'PENDING' && (isAdmin || isRep)"
                        @click="updateBidStatus(bid,'FILLED')"
                        class="btn btn-primary rounded mt-2"
                        type="button"
                        data-toggle="tooltip"
                        title="Update Status"
                      >
                        <i class="fa fa-check"></i> Accept
                      </button>
                      <button
                      v-if="bid.status === 'PENDING' && (isAdmin || isRep)"
                        @click="updateBidStatus(bid,'REJECTED')"
                        class="btn btn-danger rounded mt-2"
                        type="button"
                        data-toggle="tooltip"
                        title="Update Status"
                      >
                        <i class="fa fa-times"></i> Reject
                      </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
             <div class="d-flex align-items-center mt-4 position-relative">
                <!-- Centered Pagination -->
                <div>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    @input="getBids(currentPage)"
                  />
                </div>

                <!-- Right aligned Total Records -->
                <div class="total-records-client ml-auto">
                  <span>Total Records : {{ totalRows }}</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <v-tour name="BidsTour" :steps="steps" :options="myOptions" :callbacks="myCallbacks"></v-tour>
      <UpdateBidPrice
        v-if="showUpdateBidPriceModal"
        :bid="selectedBid"
        @close="showUpdateBidPriceModal = false ,getBids()"
      />
    </div>
</template>
<script>
import config from '@/config'
import authService from '@/authService'
import Datepicker from 'vuejs-datepicker';
// import Swal from 'sweetalert2';
import UpdateBidPrice from './UpdateBidPrice.vue';

export default {
  name: 'ClientBids',
  components: {
    Datepicker,
    UpdateBidPrice
  },
  data () {
    return {
      loading: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      sortColumn: 'id',
      sortOrder: 'DESC',
      bids: [],
      showFilters: false,
      searchValue: '',
      isAdmin: false,
      isRep: false,
      selectedStatus: '',
      selectedType: '',
      selectClient: '',
      fromDate: '',
      toDate: '',
      isClient: false,
      showUpdateBidPriceModal: false,
      selectedBid: null,

      steps: [
          {
            target: '#v-step-0',  // We're using document.querySelector() under the hood
            content: ` Track the status of all your submitted Bid and Buy requests from this page.`,
            params: {
              enableScrolling: false
            }
          },
        ],
        myCallbacks: {
          onFinish: () => {
            localStorage.setItem('client_tour_completed_bids', 'true');
            this.$router.push("/client/filter")
          },
          onSkip: () => {
            localStorage.setItem('client_tour_completed_bids', 'true');
          }
        },
        myOptions: {
          enableScrolling: false,
          labels: {
            buttonSkip: 'Skip tour',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Next'
          }
        },
    }
  },
  methods: {
    deleteBid(bid) {
        var message = `Are you sure you want to delete this bid?` ;
        this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {

           const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .put(
          config.baseUrlAutoBidder + "/offering-feed/bid-delete",
          [ bid.id],
          auth
        )
        .then(() => {
            this.$alert(
            `Bid has been deleted successfully.`,
            '',
            'success'
          )
          this.getBids();
        })

        })
      },

     async updateBidPriceModal(bid){
      this.selectedBid = bid;
      this.showUpdateBidPriceModal = true;
      // const { value: bidPrice } = await Swal.fire({
      //   title: "Please enter the new bid price",
      //   input: "number",
      //   inputLabel: "New Bid Price",
      //   inputPlaceholder: "",
      //   showCancelButton: true,
      //   confirmButtonText: "Update",
      //   inputValidator: (value) => {
      //     if (!value) {
      //       return "Enter new bid price";
      //     }
      //     if (value <= 0) {
      //       return "Bid price must be a positive number";
      //     }
      //   }
      // });
      // if (bidPrice) {
      //   this.updateBidPrice(bidPrice, bid);
      // }
    },
   
    sort(column) {
      this.sortColumn = column;
      this.sortOrder =
        this.sortOrder == "ASC"
          ? (this.sortOrder = "DESC")
          : (this.sortOrder = "ASC");
      this.getBids();
    },
    updateBidStatus(bid ,status) {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .put(
          config.baseUrlAutoBidder + "/offering-feed/accept-client-bid",
          {
            bidId: bid.id,
            updatedById: authService.getUser().id,
            status: status,
            clientName:"drl"
          },
          auth
        )
        .then(() => {
            this.$alert(
            `${bid.bidType} has been ${status === 'FILLED' ? 'accepted' : 'rejected'} successfully.`,
            '',
            'success'
          )
          this.getBids();
        })
     
    },
    getClients() {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let url = "";
      if(this.isRep && !this.isAdmin){
        url = config.baseUrlAutoBidder + "/user/client-list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&clientRepId=" + authService.getUser().id;
      } else {
        url = config.baseUrlBidSide + "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Client";
      }
      this.$http
        .get(
          url,
          auth
        )
        .then((result) => {
          this.clientList = result.data.content.map((client) => {
            return {
              id: client.id,
              clientFullName: client.firstName + " " + client.lastName,
            };
          });
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    clear () {
      this.fromDate = this.moment().subtract(7,'days').format("MM-DD-YYYY"); 
      
      this.toDate = this.moment().format("MM-DD-YYYY");
      this.searchValue = ''
      this.selectedStatus = ''
      this.selectedType = ''
      this.selectClient = ''
      this.currentPage = 1
      this.getBids()
    },
    search () {
      this.currentPage = 1
      this.getBids()
    },
    // Default dates are 'MM-DD-YYYY' strings; the datepicker returns Date objects.
    // Parse strings with an explicit format so Safari/Firefox don't produce "Invalid date".
    parseDate (value) {
      if (!value) return null
      const m = value instanceof Date
        ? this.moment(value)
        : this.moment(value, ['MM-DD-YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD'], true)
      return m.isValid() ? m : null
    },
    toApiDate (value, addDays = 0) {
      const m = this.parseDate(value)
      if (!m) return ''
      return m.clone().startOf('day').add(addDays, 'days').utc().format('YYYY-MM-DD HH:mm:ss')
    },
    getBids () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      
      const from = this.parseDate(this.fromDate)
      const to = this.parseDate(this.toDate)
      if(from && to){
        if(from.isAfter(to)){
          this.$alert("To date cannot be before start date.","","warning");
          return false;
        }
      }

      let userId = ''
      let clientRepId = ''
      if (!this.isAdmin && !this.isRep) {
        userId = authService.getUser().id
      }
      if(this.selectClient){
        userId = this.clientList.find(client => client.id === this.selectClient.id)?.id || '';
      }
      if(this.isRep  && !this.isAdmin){
        clientRepId = authService.getUser().id
      }

      this.$http
        .get(
          config.baseUrlAutoBidder +
            '/offering-feed/client-bid-listall?page=' +
            this.currentPage +
            '&size=' +
            this.perPage +
            '&search=' +
            '&sortColumn=' +
            this.sortColumn +
            '&sortOrder=' +
            this.sortOrder +
            '&statuses=' +
            this.selectedStatus +
            '&bidTypes=' +
            this.selectedType +
            '&processTypes=' +
            '&cusip=' +
             this.searchValue +
            '&userId=' +
            userId +
            '&clientRepId=' +
            clientRepId +
            '&fromDate=' +
            this.toApiDate(this.fromDate) +
            '&toDate=' +
            this.toApiDate(this.toDate, 1),
          auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements
          this.bids = result.data.content
          this.loading = false
        })
        .catch(() => (this.loading = false))
    }
  },
  mounted () {
    this.fromDate = this.moment().subtract(7,'days').format("MM-DD-YYYY");
    this.toDate = this.moment().format("MM-DD-YYYY");
    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log('accessToken is not found', err)
      } else {
        this.tenantName = role[0].split('-')[0]
        var roleArray = role.map(item => {
          return item.split('-')[1]
        })
        roleArray.includes('Rep')
          ? (this.isRep = true)
          : (this.isRep = false)
        roleArray.includes('Admin')
          ? (this.isAdmin = true)
          : (this.isAdmin = false)
        roleArray.includes('Client')
          ? (this.isClient = true)
          : (this.isClient = false)
      }
    })
      if(this.isRep || this.isAdmin){
          this.selectedStatus = 'PENDING';
          this.getClients();
      }
      this.getBids()
      if(!localStorage.getItem('client_tour_completed_bids') && this.isClient){
        this.$tours['BidsTour'].start()
      }

  }
}
</script>
<style scoped>
.loader {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: #4c6fff; /* soft neon blue */
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  margin: auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
